export const noCodeProps = [
  'extends',
  'tag',
  'text',
  'html',
  'class',
  'state',
  'data',
  'scope',
  'children',
  'childrenAs',
  'src',
  'icon',
  'iconModifier',
  'shape',
  'shapeModifier',
  'animation',
  'animationName',
  'animationDuration',
  'animationDelay',
  'animationTimingFunction',
  'transition',
  'transitionDuration',
  'transitionDelay',
  'transitionTimingFunction',
  'transitionProperty',
  'show',
  'hide',
  'height',
  'width',
  'boxSizing',
  'boxSize',
  'inlineSize',
  'blockSize',
  'minWidth',
  'maxWidth',
  'widthRange',
  'minHeight',
  'maxHeight',
  'heightRange',
  'size',
  'minBlockSize',
  'minInlineSize',
  'maxBlockSize',
  'maxInlineSize',
  'minSize',
  'maxSize',
  'borderWidth',
  'padding',
  'scrollPadding',
  'paddingInline',
  'paddingBlock',
  'paddingTop',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
  'paddingBlockStart',
  'paddingBlockEnd',
  'paddingInlineStart',
  'paddingInlineEnd',
  'margin',
  'marginInline',
  'marginBlock',
  'marginInlineStart',
  'marginInlineEnd',
  'marginBlockStart',
  'marginBlockEnd',
  'gap',
  'columnGap',
  'rowGap',
  'round',
  'borderRadius',
  'flexWrap',
  'flexFlow',
  'flexAlign',
  'flow',
  'wrap',
  'align',
  'fontSize',
  'fontFamily',
  'fontWeight',
  'area',
  'template',
  'templateAreas',
  'column',
  'columns',
  'templateColumns',
  'autoColumns',
  'columnStart',
  'row',
  'rows',
  'templateRows',
  'autoRows',
  'rowStart',
  'autoFlow',
  'inset',
  'left',
  'top',
  'right',
  'bottom',
  'verticalInset',
  'horizontalInset',
  'theme',
  'color',
  'background',
  'backgroundColor',
  'backgroundImage',
  'textStroke',
  'outline',
  'outlineOffset',
  'border',
  'borderColor',
  'borderLeft',
  'borderTop',
  'borderRight',
  'borderBottom',
  'shadow',
  'boxShadow',
  'textShadow',
  'columnRule'
]

export const colorProperties = [
  // Text Colors
  'color',
  'textDecorationColor',
  'textShadow',
  'textEmphasisColor',

  // Background Colors
  'backgroundColor',

  // Border Colors
  'borderColor',
  'borderTopColor',
  'borderRightColor',
  'borderBottomColor',
  'borderLeftColor',
  'borderBlockColor',
  'borderInlineColor',
  'borderTop',
  'borderRight',
  'borderBottom',
  'borderLeft',
  'borderBlock',
  'borderInline',

  // Outline Colors
  'outlineColor',

  // Text Decoration
  'textDecoration',
  'textEmphasis',

  // SVG and Canvas
  'fill',
  'stroke',
  'stopColor',
  'floodColor',
  'lightingColor',

  // Form Elements
  'accentColor',
  'caretColor',
  'webkitTextFillColor',
  'webkitTextStrokeColor',

  // Miscellaneous
  'boxShadow',
  'columnRuleColor',
  'webkitTapHighlightColor',
  'webkitTouchCallout'
]
